import emailjs from '@emailjs/browser';
import React, { useState } from 'react';

export default function Contact() {
  const [notification, setNotification] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    setSending(true);
    setNotification("Sending message...");
    emailjs.send(
      'service_9s0hvwj',
      'template_x4b5cff',
      {
        from_name: form.name.value,
        from_email: form.email.value,
        message: form.message.value,
      },
      'TRtM0pNEqnPa_3NdU'
    )
      .then(() => {
        setNotification('Message sent!');
        setSending(false);
        form.reset();
        setTimeout(() => setNotification(""), 3000);
      })
      .catch((error) => {
        setNotification('Failed to send message. Please try again.');
        setSending(false);
        console.error(error);
        setTimeout(() => setNotification(""), 3000);
      });
  };

  return (
    <section id="contact" className="fade-in">
      <h2>Let's Connect</h2>
      <div className="terminal-cmd">
        <span className="cmd-prompt">kartik@portfolio</span><span className="cmd-path">:~/projects$</span> ./contact.sh
      </div>
      <div className="contact-content">
        <div className="contact-info">

          <div className="contact-links">
            <a className="contact-chip" href="mailto:kartiknaik560@gmail.com">
              <i className="fa-solid fa-envelope"></i>
              <span>Email</span>
            </a>

            <a className="contact-chip" href="https://www.linkedin.com/in/kartik-naik-194326324/" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-linkedin"></i>
              <span>LinkedIn</span>
            </a>

            <a className="contact-chip" href="https://github.com/KARTIKNAIK18" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-github"></i>
              <span>GitHub</span>
            </a>
          </div>
        </div>
        
        {notification && (
          <div style={{
            position: 'fixed',
            top: '24px',
            right: '24px',
            background: notification === 'Message sent!' ? '#4caf50' : (notification === 'Sending message...' ? '#333' : '#f44336'),
            color: '#fff',
            padding: '8px 18px',
            borderRadius: '6px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
            zIndex: 9999,
            fontWeight: '500',
            fontSize: '1rem',
            minWidth: '120px',
            textAlign: 'center',
            opacity: 0.95,
            letterSpacing: '0.02em',
          }}>
            {notification}
          </div>
        )}
        <form className="contact-form" id="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <input type="text" name="name" placeholder="Your name" required />
            <input type="email" name="email" placeholder="Your email" required />
          </div>    
          <textarea name="message" rows="4" placeholder="Write your message here..." required></textarea>
          <button type="submit" className="submit-btn" disabled={sending}>
            <i className="fa-solid fa-paper-plane"></i>
            {sending ? 'Sending...' : 'Send message'}
          </button>
        </form>
      </div>
    </section>
  );
}